'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');

  console.error = function () {
    var _error = console.error;
    var re = /^Warning: Each child in a list should have a unique "key" prop/;
    return function () {
      var line = arguments.length <= 0 ? undefined : arguments[0];

      if (re.test(line)) {// Ignore key warnings
      } else {
        _error.apply(void 0, arguments);
      }
    };
  }();
}